import { Base } from '@studiometa/js-toolkit';
import Cookies from 'js-cookie';

/**
 * Homepage class.
 */
export default class Banner extends Base {
  /**
   * Class config
   * @type {object}
   */
  static config = {
    name: 'Banner',
    refs: ['btn'],
  };

  /**
   * Get cookie for the banner
   * @returns {string} Current banner status f Session Cookies
   */
  get currentBanner() {
    return Cookies.get('hide_banner');
  }

  /**
   * Mounted
   */
  mounted() {
    if (this.currentBanner === 'yes') {
      this.$destroy();
      return;
    }
    this.$el.classList.add('flex');
    this.$el.classList.remove('hidden');

    // Add a margin to HeroSlider for better mobile spacing
    const hero = document.querySelector('[data-component="HeroSlider"]');
    if (hero) {
      const { height } = this.$el.getBoundingClientRect();
      hero.style.marginTop = `${height}px`;
    }
  }

  /**
   * Btn clicks
   */
  onBtnClick() {
    this.$el.classList.add('hidden');
    Cookies.set('hide_banner', 'yes');
  }
}
